module.exports = __webpack_public_path__ + "img/88.a5b7af18.jpg";